export default `
  mutation($articlesIds: [String], $originModel: String) {
    approveArticles(approvedArticles: { articlesIds: $articlesIds, originModel: $originModel }) {
      articlesIds
    }
  }
`;